import { render } from "./inspectionCenter.vue?vue&type=template&id=405c9ea6&scoped=true"
import script from "./inspectionCenter.vue?vue&type=script&lang=js"
export * from "./inspectionCenter.vue?vue&type=script&lang=js"

import "./inspectionCenter.vue?vue&type=style&index=0&id=405c9ea6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405c9ea6"]])

export default __exports__